import { render, staticRenderFns } from "./SensitiveSkinInfoModal.vue?vue&type=template&id=1ab19b9c&scoped=true"
import script from "./SensitiveSkinInfoModal.vue?vue&type=script&lang=js"
export * from "./SensitiveSkinInfoModal.vue?vue&type=script&lang=js"
import style0 from "./SensitiveSkinInfoModal.vue?vue&type=style&index=0&id=1ab19b9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab19b9c",
  null
  
)

export default component.exports